import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/PageHero";
import SafetyNote from "@/components/SafetyNote";
import RichText from "@/components/RichText";
import { Reveal, PrimaryButton } from "@/components/primitives";
import Snippet from "@/components/Snippet";
import { useSite } from "@/context/SiteContext";
import { ASSETS, LIB } from "@/data/content";

export default function AboutQHHT() {
  const { page, img } = useSite();
  const p = page("about_qhht");

  return (
    <div>
      <PageHero {...p.hero} image={img("about_qhht_hero", LIB.coastMistyShore)} imageAlt="Soft morning light over a misty South Devon shoreline" />

      <section className="py-20 md:py-28">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <Reveal><RichText html={p.body_html} /></Reveal>
        </div>
      </section>

      <section className="relative h-[36vh] md:h-[44vh] overflow-hidden">
        <img src={img("about_qhht_band", LIB.coastSunriseHills)} alt="Sunrise over the South Devon coast" className="h-full w-full object-cover object-center" />
        <div className="absolute inset-0 bg-brand-forest-dark/25" />
      </section>

      <section className="pb-20 md:pb-28 pt-20 md:pt-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal><SafetyNote /></Reveal>
          <div className="mt-12 text-center">
            <PrimaryButton as={Link} to="/what-to-expect" data-testid="qhht-expect-btn">
              <Snippet k="about_qhht.cta" fallback="What happens in a session" /> <ArrowRight size={18} strokeWidth={1.5} />
            </PrimaryButton>
          </div>
        </div>
      </section>
    </div>
  );
}
